/* eslint-disable */

// Queries
export const phoenixPrearrivalProperty = require('./queries/phoenixPrearrivalProperty.graphql');
export const phoenixPrearrivalGetCustomerPreferenceFeatures = require('./queries/phoenixPrearrivalGetCustomerPreferenceFeatures.graphql');
export const phoenixPrearrivalUpdateCustomerPreferenceFeatures = require('./mutations/phoenixPrearrivalUpdateCustomerPreferenceFeatures.graphql');
